import { v4 as uuid } from 'uuid';
import { eMortgageDocumentType } from './eMortgageDocumentType';
import {
  convertMortgageDocumentDataToMortgageDocumentResponse,
  convertMortgageDocumentResponseToMortgageDocumentData,
  IMortgageDocumentData,
  IMortgageDocumentResponse,
} from './IMortgageDocument';
import { DateTime } from 'luxon';
import { isNil } from 'lodash';

export interface IMortgageResponse {
  id: string;
  created_at?: string;
  mortgagor_name?: string | null;
  lender_name?: string | null;
  trustee_name?: string | null;
  document_type?: eMortgageDocumentType | null;
  other_document_type?: string | null;
  recorded_date?: string | null;
  original_date?: string | null;
  maturity_date?: string | null;
  original_loan_amount?: number | null;
  book?: string | null;
  instrument_number?: string | null;
  additional_information?: string | null;
  documents?: IMortgageDocumentResponse[] | null;
}

export interface IMortgageData {
  id: string;
  createdAt?: string;
  mortgagorName?: string | null;
  lenderName?: string | null;
  trusteeName?: string | null;
  documentType?: eMortgageDocumentType | null;
  otherDocumentType?: string | null;
  recordedDate?: string | null;
  originalDate?: string | null;
  maturityDate?: string | null;
  originalLoanAmount?: number | null;
  book?: string | null;
  instrumentNumber?: string | null;
  additionalInformation?: string | null;
  documents?: IMortgageDocumentData[] | null;
}

export const createDefaultMortgageData = (): IMortgageData => ({
  id: uuid(),
  createdAt: DateTime.local().toISO(),
});

export const convertMortgageResponseToMortgageData = (res: IMortgageResponse): IMortgageData => ({
  id: res.id,
  createdAt: res.created_at,
  mortgagorName: res.mortgagor_name,
  lenderName: res.lender_name,
  trusteeName: res.trustee_name,
  documentType: res.document_type,
  otherDocumentType: res.other_document_type,
  recordedDate: res.recorded_date,
  originalDate: res.original_date,
  maturityDate: res.maturity_date,
  originalLoanAmount: res.original_loan_amount,
  book: res.book,
  instrumentNumber: res.instrument_number,
  additionalInformation: res.additional_information,
  documents: isNil(res.documents)
    ? res.documents
    : res.documents!.map((document) => convertMortgageDocumentResponseToMortgageDocumentData(document)),
});

export const convertMortgageDataToMortgageResponse = (data: IMortgageData): IMortgageResponse => ({
  id: data.id,
  created_at: data.createdAt,
  mortgagor_name: data.mortgagorName,
  lender_name: data.lenderName,
  trustee_name: data.trusteeName,
  document_type: data.documentType,
  other_document_type: data.otherDocumentType,
  recorded_date: data.recordedDate,
  original_date: data.originalDate,
  maturity_date: data.maturityDate,
  original_loan_amount: data.originalLoanAmount,
  book: data.book,
  instrument_number: data.instrumentNumber,
  additional_information: data.additionalInformation,
  documents: isNil(data.documents)
    ? data.documents
    : data.documents!.map((document) => convertMortgageDocumentDataToMortgageDocumentResponse(document)),
});
